import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TribunaleaAuthProvider } from "@tribunalea/auth/react";
import { CreditExhaustionProvider, RouterProvider } from "@tribunalea/ui";
import App from "./App.jsx";
import "@tribunalea/ui/styles.css";
import "./styles.css";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const liveContent = (
  <RouterProvider defaultPath="/creditos">
    <App authEnabled />
  </RouterProvider>
);
const demoContent = (
  <RouterProvider defaultPath="/creditos">
    <App authEnabled={false} />
  </RouterProvider>
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CreditExhaustionProvider creditsHref="/creditos">
      <TribunaleaAuthProvider
        publishableKey={clerkPublishableKey}
        apiUrl={import.meta.env.VITE_API_URL || "http://localhost:4000"}
        demoFallback={demoContent}
      >
        {liveContent}
      </TribunaleaAuthProvider>
    </CreditExhaustionProvider>
  </StrictMode>,
);
